export const color = {
  colorPrimary: '#1e3a8a',
  colorWarning: '#f59e0b',
  colorSuccess: '#15803d',
  colorDanger: '#dc2626',
  colorInfo: '#00abda',
  colorLight: '#f3f4f6',
  colorSecondary: '#6b7280',
  colorDark: '#0f172a'
}